import PropTypes from 'prop-types'
import React from 'react'

import RenderInView from 'components/RenderInView'
import { LocalizationContext } from 'contexts/Localization'
import { H2 } from 'styles/components/typography'

import IconsWithDescription from './components/IconsWithDescription'
import {
  BoxBaseStyled,
  TextHighlightWrapper,
  TextHighlight,
  RelativeContainer,
} from './styles'

const BNutritionHowCanHelp = ({ data }) => {
  const { paths } = React.useContext(LocalizationContext)

  return (
    <RenderInView display="block">
      <BoxBaseStyled image={`${paths.shared}/vegetables_v2`}>
        <RelativeContainer>
          <H2 as="h3" dangerouslySetInnerHTML={{ __html: data.title }} />
          <TextHighlightWrapper>
            <TextHighlight
              dangerouslySetInnerHTML={{ __html: data.description }}
            />
          </TextHighlightWrapper>
          <IconsWithDescription {...{ data }} />
        </RelativeContainer>
      </BoxBaseStyled>
    </RenderInView>
  )
}

BNutritionHowCanHelp.propTypes = {
  data: PropTypes.object.isRequired,
}

export default BNutritionHowCanHelp
